import React from 'react';

/**
 * TimeField component - handles time input type
 */
function TimeField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <input
            type="time"
            id={fieldId}
            value={value || ''}
            onChange={(e) => onChange(index, e.target.value)}
            className="w-full px-3 py-2 bg-surface-2 text-content border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-amber"
        />
    );
}

export default TimeField;
